export default __webpack_public_path__ + "static/media/young-girl-learning.5027d326.png";